import { ITimezone } from 'features/user';

import { UpdateGroupeParams, GroupeUser } from './../store/types';

type TransformGroupeInfoProps = Omit<UpdateGroupeParams, 'id'>

export const transformGroupeInfo = ({ userIds, coachId, priceIndividual, ...req }: TransformGroupeInfoProps) => ({
  ...req,
  'user_ids': userIds,
  'coach_id': coachId,
  'price_individual': priceIndividual
});


export const convertGroupeUsersToTable = (timezone: ITimezone, users: GroupeUser[]) => users.map((user) => ({
  ...user,
  key: user.id,
}));
